import '@js-joda/timezone';
import { Card, Col, Container, Row } from "react-bootstrap";

//spotsync data
import { useNavigate } from "react-router-dom";

import { cents, showMoneyShort } from "../../Data/Money";

import { pluralize } from "../../Data/English";
import { HeaderText } from "../../Controls/HeaderText";
import { PageTitle } from '../../Controls/PageTitle';
import { createApiService } from '../../shared/apiConfig';
import { OperatorApi, ServerRequestsAnalyticsOverviewResponse } from '../../shared/api/axios-client';
import { useEffect, useState } from 'react';

interface OverviewCardProps {
    size?:      number;
    label?:     string;    
    children?:  React.ReactNode;
    className?: string;
    style?:     React.CSSProperties;
    to?:        string;
}

function OverviewCard( { size      = 1,
                         label     = "",
                         className = "",
                         children  = <></>,        
                         style     = {},
                         to }: OverviewCardProps ) {

    const nav = useNavigate();
    
    if( !!to ) {
        className += "zoom-small-link";
    }
    return <Col xs={6} lg={6} xl={3}>
        <Card className={`shadow py-2 h-100 border-2 zoom-small rounded-4 text-nowrap ${className}`}
              onClick={ () => to !== undefined ? nav( to ) : 0 }>
            <Card.Body className="d-flex flex-column">
                <div className={`w-100 flex-grow-1 fs-${size} text-center`}>
                    {children}
                </div>
                <div className="text-center text-muted">
                    Total {label}
                </div>
            </Card.Body>
        </Card>
    </Col>;
}

export function AdminOverviewPage() {    
  
    const operatorService = createApiService(OperatorApi)
    const [overviewResponse, setOverviewResponse] = useState<ServerRequestsAnalyticsOverviewResponse | null>(null)

    function facilityLink( link: string ) { return `/facility/`; }
    useEffect(()=>{
        const getOverview = async ()=>{
            const overviewResponse = await operatorService.analyticsOverview({})
            setOverviewResponse(overviewResponse.data)
        }
        getOverview()
    },[])
    return <Container fluid className="mb-3">
        <Row>
            <Col>
                <PageTitle>
                    Overview
                </PageTitle>
            </Col>
        </Row>
        <Row className="mt-3">
            <Col className="d-flex align-items-center">
                <HeaderText>Stats</HeaderText>
                <div className="flex-grow-1">

                </div>
            </Col>
        </Row>
        <Row className="gy-3 gx-3">
            <OverviewCard label="Operators" to="/admin/operators">
                {overviewResponse?.operatorsCount}
            </OverviewCard>
            <OverviewCard label="Facilities">
                {overviewResponse?.facilitiesCount}
            </OverviewCard>
            <OverviewCard label="Users">
                {overviewResponse?.usersCounts}                
            </OverviewCard>            
        </Row>
    </Container>;
}
